module.exports = "/assets/data/16fc679f414d001e9abb546df27ecaa2-NE10.data.json";